import * as React from "react";

const NavSection = React.memo(({ nav }: { nav: React.ReactNode | null }) => {
  if (nav === null) return null;
  return <div>{nav}</div>;
});

const ContentSection = React.memo(({ content }: { content: React.ReactNode }) => {
  return <div>{content}</div>;
});

interface Props {
  nav: React.ReactNode | null;
  content: React.ReactNode;
}
export const ContentLayout: React.FC<Props> = ({ nav = null, content }) => {
  return (
    <div className={`cpln-content-layout ${nav === null ? "without-nav" : ""}`}>
      <NavSection nav={nav} />
      <ContentSection content={content} />
    </div>
  );
};
